var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\tVous avez terminé votre formation. Cliquez sur le bouton \"Suivant\" en bas à droite.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }